import React from "react";

const SvgArrowBack = props => (
  <svg width="1em" height="1em" viewBox="0 0 40 40" {...props}>
    <path
      fill="currentColor"
      d="M33.4 18.4v3.2H13l9.3 9.4-2.3 2.4L6.6 20 20 6.6 22.3 9 13 18.4h20.4z"
    />
  </svg>
);

export default SvgArrowBack;
